module.exports = __webpack_public_path__ + "assets/img/config-table-8337aec6.png";